import { UpdateManageSearchParams, GetCustomersList, GetUsersList, GetCustomer, GetUser, UpdateCountryList } from '../actions/actionTypes';
import API from '../../services/requestService';
import ENDPOINT from '../../services/endpoints';
import { showToast, showLoader, setModalError } from './common';
import { TOAST_HEADER, MESSAGES } from '../../services/constants';
import { IListParams, UserTypes, ICustomer, IUser } from '../../shared/models/adminModels';
import { Dispatch } from 'redux';

export const getUsersList = (params: IListParams) => async (dispatch: any) => {
  dispatch(showLoader(true));
  try {
    const { data: userResponse }: any = await API.post(ENDPOINT.getUsers, params);
    dispatch(showLoader(false));
    userResponse && userResponse.isSuccess
      ? dispatch({
        type: GetUsersList,
        payload: { ...params, ...userResponse.data }
      })
      : dispatch(showToast(TOAST_HEADER.ERROR, userResponse.message));
    return userResponse;
  } catch (e) {
    console.error('getUsers', e);
    dispatch(showLoader(false));
    dispatch(showToast(TOAST_HEADER.ERROR, MESSAGES.common));
    return e;
  }
}

export const getCustomersList = (params: IListParams) => async (dispatch: any) => {
  dispatch(showLoader(true));
  try {
    const { data: userResponse }: any = await API.post(ENDPOINT.getCustomers, params);
    dispatch(showLoader(false));
    userResponse.isSuccess
      ? dispatch({
        type: GetCustomersList,
        payload: { ...params, ...userResponse.data }
      })
      :
      dispatch(showToast(TOAST_HEADER.ERROR, userResponse.message));
    return userResponse;
  } catch (e) {
    console.error('getCustomers', e);
    dispatch(showLoader(false));
    dispatch(showToast(TOAST_HEADER.ERROR, MESSAGES.common));
    return e;
  }
}

export const getCustomer = (customerId: string) => (dispatch: any) => {
  return new Promise(async (resolve, reject) => {
    dispatch(showLoader(true));
    try {
      const { data: response } = await API.post(ENDPOINT.getCustomer + `?customerId=${customerId}`);
      dispatch(showLoader(false));
      response.isSuccess
        ? dispatch({
          type: GetCustomer,
          payload: { ...response.data }
        })
        :
        dispatch(showToast(TOAST_HEADER.ERROR, response.message));
      return resolve(response.data);
    } catch (e) {
      console.error('getCustomer', e);
      dispatch(showLoader(false));
      dispatch(showToast(TOAST_HEADER.ERROR, MESSAGES.common));
      return reject(e);
    }
  });
}

export const saveCustomer = (customer: ICustomer, isEdit: boolean, fromModal = false) => (dispatch: Dispatch<any>) => {
  return new Promise(async (resolve, reject) => {
    dispatch(showLoader(true));
    try {
      const { data: response } = await API.post(isEdit ? ENDPOINT.updateCustomer : ENDPOINT.registerCustomer, customer);
      dispatch(showLoader(false));
      if (response.isSuccess) {
        dispatch(showToast(TOAST_HEADER.SUCCESS, response.message));
      } else {
        if (!fromModal) {
          dispatch(showToast(TOAST_HEADER.ERROR, response.message));
        } else {
          dispatch(setModalError(response.message));
        }
      }
      return resolve(response);
      // return response.isSuccess;
    } catch (e) {
      console.error('saveCustomer', e);
      dispatch(showLoader(false));
      dispatch(showToast(TOAST_HEADER.ERROR, MESSAGES.common));
      return reject(e);
    }
  })
}

export const getUser = (userId: string) => async (dispatch: any) => {
  dispatch(showLoader(true));
  try {
    const { data: response } = await API.post(ENDPOINT.getUser + `?userId=${userId}`);
    dispatch(showLoader(false));
    response.isSuccess
      ? dispatch({
        type: GetUser,
        payload: { ...response.data }
      })
      :
      dispatch(showToast(TOAST_HEADER.ERROR, response.message));
  } catch (e) {
    console.error('getUser', e);
    dispatch(showLoader(false));
    dispatch(showToast(TOAST_HEADER.ERROR, MESSAGES.common));
    return e;
  }
}

export const saveUser = (user: IUser, isEdit: boolean) => async (dispatch: Dispatch<any>) => {
  dispatch(showLoader(true));
  try {
    const { data: response } = await API.post(isEdit ? ENDPOINT.updateUser : ENDPOINT.registerUser, user);
    dispatch(showLoader(false));
    dispatch(showToast(response.isSuccess ? TOAST_HEADER.SUCCESS : TOAST_HEADER.ERROR, response.message));
    return response.isSuccess;
  } catch (e) {
    console.error('saveUser', e);
    dispatch(showLoader(false));
    dispatch(showToast(TOAST_HEADER.ERROR, MESSAGES.common));
    return e;
  }
}

export const updateUserProfile = (user: IUser) => async (dispatch: Dispatch<any>) => {
  dispatch(showLoader(true));
  try {
    const { data: response } = await API.post(ENDPOINT.updateUserProfile, user);
    dispatch(showLoader(false));
    dispatch(showToast(response.isSuccess ? TOAST_HEADER.SUCCESS : TOAST_HEADER.ERROR, response.message));
    return response.isSuccess;
  } catch (e) {
    console.error('saveUser', e);
    dispatch(showLoader(false));
    dispatch(showToast(TOAST_HEADER.ERROR, MESSAGES.common));
    return e;
  }

}

export const updateManageSearchParams = (params: IListParams, userType: UserTypes) => (dispatch: any) => {
  dispatch({
    type: UpdateManageSearchParams,
    payload: { params, userType }
  });
}

export const getCountryList = () => async (dispatch: any) => {
  try {
    dispatch(showLoader(true));
    const { data: response } = await API.get(ENDPOINT.getCountries);
    dispatch({
      type: UpdateCountryList,
      payload: response.data,
    });
  } catch (e) {
    dispatch(showToast(TOAST_HEADER.ERROR, MESSAGES.countryList));
    dispatch({
      type: UpdateCountryList,
      payload: [],
    });
  } finally {
    dispatch(showLoader(false));
  }

}